'use client'

import React, { memo } from 'react'
import dynamic from 'next/dynamic'

const RecentSearchWidgetDynamic = dynamic(
    () => import('@cleartrip/ct-platform-recent-search-widget').then(mod => mod.RecentSearchWidget),
    {
        ssr: false,
        loading: () => <></>
    }
)

export type RecentSearchWidgetWrapperProps = React.ComponentProps<typeof RecentSearchWidgetDynamic>

const RecentSearchWidgetWrapper = memo((props: RecentSearchWidgetWrapperProps) => {
    return <RecentSearchWidgetDynamic {...props} />
})

RecentSearchWidgetWrapper.displayName = 'RecentSearchWidgetWrapper'

export default RecentSearchWidgetWrapper
